module.exports = __webpack_public_path__ + "static/output-9180b69dbc3847057d9538f795e25ff5.webm";